/* eslint-disable */
import API from "../utils/axios";

const FrontendAPI = {
  landingPage: async () => {
    const { data } = await API.get(`frontEnd/landingPage`);

    return data;
  },

  getPageBySlug: async ({ slug }) => {
    const { data } = await API.get(`frontEnd/page/${slug}`);

    return data;
  },

  headerFooter: async () => {
    const { data } = await API.get(`frontEnd/headerFooter`);

    return data;
  },

  career: async () => {
    const { data } = await API.get(`frontEnd/career`);

    return data;
  },

  officePinPoint: async () => {
    const { data } = await API.get(`frontEnd/officePinPoint`);

    return data;
  },

  clientNPartner: async (type) => {
    const { data } = await API.get(`frontEnd/clientNPartner/${type}`);

    return data;
  },

  company: async () => {
    const { data } = await API.get(`frontEnd/company`);

    return data;
  },

  FAQ: async () => {
    const { data } = await API.get(`frontEnd/FAQ`);

    return data;
  },

  post: async ({ sortField, sortType, currentPage, pageSize }) => {
    const { data } = await API.get(
      `/frontEnd/post?sort=${sortField}&sortType=${sortType}&pageSize=${pageSize}&currentPage=${currentPage}`
    );

    return data;
  },

  getPostBySlug: async ({ slug }) => {
    const { data } = await API.get(`frontEnd/post/${slug}`);

    return data;
  },

  contactEmail: async (params) => {
    const { data } = await API.post(`frontEnd/contactEmail`, params);

    return data;
  },

  getContactEmail: async () => {
    const { data } = await API.get(`frontEnd/contactEmail`);

    return data;
  },

  sendJobApplication: async (params) => {
    const { data } = await API.post(`frontEnd/sendJobApplication`, params);

    return data;
  },

  WCU: async () => {
    const { data } = await API.get(`frontEnd/why-choose-us`);

    return data;
  },

  sex: async () => {
    const { data } = await API.get(`frontEnd/sex`);

    return data;
  },

  maritalStatus: async () => {
    const { data } = await API.get(`frontEnd/maritalStatus`);

    return data;
  },

  educationDegree: async () => {
    const { data } = await API.get(`frontEnd/educationDegree`);

    return data;
  },

  lastJobDuration: async () => {
    const { data } = await API.get(`frontEnd/lastJobDuration`);

    return data;
  },

  careerDivision: async () => {
    const { data } = await API.get(`frontEnd/careerDivision`);

    return data;
  },

  careerDivisionById: async ({ id, search }) => {
    const { data } = await API.get(
      `frontEnd/careerDivision/${id}?search=${search}`
    );

    return data;
  },

  careerById: async (id) => {
    const { data } = await API.get(`frontEnd/career/${id}`);

    return data;
  },
};

export default FrontendAPI;
